//***********************************************************************************************test data****/

export const getTestLaneList = () => {
    return [{
        laneID: '123',
        laneName: 'DOMESTIC LANE',
        totalMediaUploaded: 320,
        totalMedia: 420,
        totalUnits: 140,
        uploadError: 3
    },
    {
        laneID: '456',
        laneName: 'METRIC SPORT/CRUISER LANE',
        totalMediaUploaded: 240,
        totalMedia: 240,
        totalUnits: 80
    },
    {
        laneID: '789',
        laneName: 'OFF-ROAD/BOAT/RV LANE',
        totalMediaUploaded: 130,
        totalMedia: 300,
        totalUnits: 100
    },
    {
        laneID: '1011',
        laneName: 'ATV/PWC/RV',
        totalMediaUploaded: 0,
        totalMedia: 180,
        totalUnits: 60
    },
    {
        laneID: '1213',
        laneName: 'KAWASAKI LANE',
        totalMediaUploaded: 10,
        totalMedia: 450,
        totalUnits: 150
    }
    ];
}

export const getTestAuctionList = () => {
    return [{
        auctionID: '1234',
        auction: 'NPA ATLANTA',
        auctionDate: '09/4/2020',
        startTime: '8:00 am',
        endTime: '3:00 pm',
        totalProxybids: 20,
        totalRegisteredUsers: 30,
    },
    {
        auctionID: '5678',
        auction: 'NPA PHILADELPHIA',
        auctionDate: '09/9/2020',
        startTime: '8:00 am',
        endTime: '3:00 pm',
        totalProxybids: 5,
        totalRegisteredUsers: 15,
    },
    {
        auctionID: '1112',
        auction: 'NPA CINCINNATI',
        auctionDate: '09/10/2020',
        startTime: '8:00 am',
        endTime: '3:00 pm',
        totalProxybids: 11,
        totalRegisteredUsers: 32,
    },
    {
        auctionID: '1314',
        auction: 'NPA DALLAS',
        auctionDate: '09/16/2020',
        startTime: '7:00 am',
        endTime: '3:00 pm',
        totalProxybids: 16,
        totalRegisteredUsers: 34,
    },
    {
        auctionID: '1516',
        auction: 'NPA MADISON',
        auctionDate: '09/17/2020',
        startTime: '8:00 am',
        endTime: '3:00 pm',
        totalProxybids: 8,
        totalRegisteredUsers: 30,
    }
    ];
}
 //*************************************************************************************************************************end test data***/
